import * as React from "react";
import { useEffect, useState } from "react";
import API from "../../Api";
import { useSession } from "../../session/Context";
import { Id, toast } from "react-toastify";

import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import CSVReader from "../../CSVReader";
import { UploadFile } from "@mui/icons-material";
import { Navigate, useNavigate } from "react-router-dom";
import { getCredentialSubject, makeValueOnSchema } from "../../schema/Utils";
import { createCSVFile, csvHeaders, importCSVFile } from "../../schema/Csv";
import DragDrop from "./Drag&Drop";

interface CreateCredentialProps {
  scope: any;
}

export default function MultiCreateCredential(props: CreateCredentialProps) {
  const { brand } = useSession();
  const navigate = useNavigate();

  // Part one
  const [selectScopes, setSelectScopes] = useState<any[]>([]);
  const [selectedScope, setSelectedScope] = useState("");

  const [selectedAuthType, setSelectedAuthType] = useState("");

  const [data, setData] = useState<any>();

  // Get credential types
  useEffect(() => {
    setSelectScopes(
      Object.keys(props.scope)
        .map((scope) => props.scope[scope])
        .filter((scope) => scope.factory === "Schema Factory")
        .map((scope) => {
          return {
            label: scope.schema.content.title,
            value: scope.scope,
            tooltip: scope.schema.content.description,
          };
        })
    );
  }, []);

  const onCreateCredential = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    try {
      let emails = Object.keys(data);
      let preparedRequests = emails
        .map((email: string) => {
          return data[email].map((val: any) => {
            let body = {
              email: email,
              type: props.scope[selectedScope].id,
              subject: val,
            };
            if (
              props.scope[selectedScope].id ===
              "authorized.verifier.credential.v1"
            ) {
              body.subject = {
                permissions: [
                  {
                    type: props.scope[selectedAuthType].metadata.types[
                      props.scope[selectedAuthType].metadata.types.length - 1
                    ],
                  },
                ],
              };
            }
            return body;
          });
        })
        .reduce((prev, curr) => [...prev, ...curr]);
      const requestLength = preparedRequests.length;
      let toastId = toast("Uploading " + emails.length + " entries...", {
        autoClose: false,
      });
      let counter = 0;
      const requests = preparedRequests.map(
        (body: any) =>
          new Promise((resolver, reject) => {
            let count = counter;
            counter++;
            API(
              "/api/v1/brand" +
                (brand == "" ? "/root" : "/" + brand) +
                "/offer",
              {
                method: "POST",
                body: JSON.stringify(body),
              }
            )
              .then((response) => {
                toast.update(toastId, {
                  render: "Uploaded " + count + "/" + requestLength,
                });
                resolver(response);
              })
              .catch((e) => {
                toast.update(toastId, {
                  render: "Error uploading entry " + count + ", reason: " + e,
                  type: toast.TYPE.ERROR,
                  autoClose: 5000,
                });
                reject(e);
              });
          })
      );
      Promise.all(requests).then(() => {
        toast.update(toastId, {
          render: "Uploaded and sent every entry successfully",
          type: toast.TYPE.SUCCESS,
          autoClose: 5000,
        });
      });
    } catch (e) {
      console.error(e);
    }
  };

  const handleChangeScope = (event: SelectChangeEvent) => {
    setSelectedScope(event.target.value);
    setSelectedAuthType("");
    setData({});
  };

  return (
    <>
      <div className="cards ">
        <div className="issue-credentials">
          <form onSubmit={onCreateCredential} className="form">
            <div className="add_issuance__cards">
              <div className="cards">
                <div>
                  <label>Credential Template</label>

                  <Select
                    required
                    className="template-field"
                    value={selectedScope}
                    onChange={handleChangeScope}
                    displayEmpty
                    renderValue={(value) => {
                      if (value == "") {
                        return (
                          <em style={{ color: "#8e8e8e", fontSize: "15px" }}>
                            Select Credential Template
                          </em>
                        );
                      } else {
                        return (
                          <em style={{ fontSize: "15px" }}>
                            {props.scope[selectedScope].schema.content.title}
                          </em>
                        );
                      }
                    }}
                  >
                    {selectScopes ? (
                      selectScopes.map((item, index) => {
                        return (
                          <MenuItem
                            selected={index === 0}
                            key={item.value}
                            value={item.value}
                          >
                            {item.label}
                          </MenuItem>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </Select>
                </div>
              </div>
            </div>

            {props.scope[selectedScope] &&
              props.scope[selectedScope].id !==
                "authorized.verifier.credential.v1" &&
              selectedScope !== "" && (
                <DragDrop
                  selectedScope={props.scope[selectedScope].id}
                  setData={setData}
                />
              )}
            {props.scope[selectedScope] && props.scope[selectedScope].id ===
              "authorized.verifier.credential.v1" && (
              <>
                <label>Authorize Recipient's Verification Permissions</label>
                <Select
                  required
                  className="template-field"
                  value={selectedAuthType}
                  onChange={(event: SelectChangeEvent) => {
                    setSelectedAuthType(event.target.value);
                  }}
                  displayEmpty
                  renderValue={(value) => {
                    if (value == "") {
                      return (
                        <em style={{ color: "#8e8e8e", fontSize: "15px" }}>
                          Select Credential Template
                        </em>
                      );
                    } else {
                      return (
                        <em style={{ fontSize: "15px" }}>
                          {props.scope[selectedAuthType].schema.content.title}
                        </em>
                      );
                    }
                  }}
                >
                  {selectScopes
                    .filter(
                      (item) => item.id !== "authorized.verifier.credential.v1"
                    )
                    .map((item, index) => {
                      return (
                        <MenuItem
                          selected={index === 0}
                          key={item.value}
                          value={item.value}
                        >
                          {item.label}
                        </MenuItem>
                      );
                    })}
                </Select>
              </>
            )}
            {selectedAuthType !== "" && (
              <DragDrop
                selectedScope={props.scope[selectedScope].id}
                setData={setData}
              />
            )}

            <input
              className="form-submit-btn btn btn-primary issuance__btn"
              disabled={selectedScope === ""}
              key="submit"
              type="submit"
              value="Issue Credentials"
            ></input>
          </form>
        </div>
      </div>
    </>
  );
}
